import React from 'react'
import '../stylesheets/tabs.sass'
import { ScrollSyncPane } from 'react-scroll-sync'
import _ from 'lodash'

const IndexTabs = (props) => {
  return (
    <div className='tabs'>
      <div className='tabs_wrapper'>
        <div
          onClick={ () => props.setTab('accounting') }
          className={ props.activeTab === 'accounting' ? 'tab_one tab_one_selected' : 'tab_one' }
          style={{
            minWidth: 200,
            width: `${100/2}%`
          }}>
          <div>
            Accounting
          </div>
        </div>
        <div
          onClick={ () => props.setTab('tips') }
          className={ props.activeTab === 'tips' ? 'tab_two tab_two_selected' : 'tab_two' }
          style={{
            minWidth: 200,
            width: `${100/2}%`
          }}>
          <div>
            Tips
          </div>
        </div>
      </div>
    </div>
  )
}



export default IndexTabs




// WEBPACK FOOTER //
// ./src/Accounting/IndexTabs.jsx